(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ContributionLoopAddonController', ContributionLoopAddonController);

    ContributionLoopAddonController.$inject = ['$state', 'CompanyStatus', 'CollectivitySize', 'City', 'Sector'];

    function ContributionLoopAddonController($state, CompanyStatus, CollectivitySize, City, Sector) {
        var vm = this;

        vm.isContributionsOpen = false;
        vm.isSuperLoopOpen = false;

        vm.collectivitySizes = [];
        vm.cities = [];
        vm.sectors = [];
        vm.companyStatuses = [];
        vm.superLoopForm = {
            isCompany: true // Company or collectivity
        };
        vm.search = search;

        CollectivitySize.query(storeCollectivitySizes);
        City.query(storeCities);
        Sector.query(storeSectors);
        CompanyStatus.query(storeCompanyStatuses);

        vm.switchToCompany = switchToCompany;
        vm.switchToCollectivity = switchToCollectivity;

        function search() {
            $state.go('super-loop', vm.superLoopForm);
        }

        function switchToCompany() {
            vm.superLoopForm.isCompany = true;
        }

        function switchToCollectivity() {
            vm.superLoopForm.isCompany = false;
        }

        function storeCities(cities) {
            vm.cities = cities;
        }

        function storeSectors(sectors) {
            vm.sectors = sectors;
        }

        function storeCollectivitySizes(collectivitySizes) {
            vm.collectivitySizes = collectivitySizes;
        }

        function storeCompanyStatuses(companyStatuses) {
            vm.companyStatuses = companyStatuses;
        }
    }
})();
